import { HeaderText as StyledHeaderText } from './HeaderText.styles';
import * as React from 'react';

export interface HeaderTextProps {
  /**
   * Header text contents
   */
  label: string;
  /**
   * How heavy is the header's weight?
   */
  weight?: 'regular' | 'light' | 'medium';
  size?: 'small' | 'regular' | 'medium' | 'large';
  color?: string;
  margin?: string;
  'data-testid'?: string;
}

/**
 * The most prominent text on the screen, used in the Header.
 */
export const HeaderText: React.FC<HeaderTextProps> = ({
  weight = 'regular',
  label,
  size,
  color,
  margin,
  ...props
}: HeaderTextProps) => {
  return (
    <StyledHeaderText
      weight={weight}
      size={size}
      color={color}
      margin={margin}
      data-testid={props['data-testid']}
    >
      {label}
    </StyledHeaderText>
  );
};

export default HeaderText;
